import { CommonModule } from '@angular/common';
import { inject, LOCALE_ID, NgModule, provideAppInitializer } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { LocaleService } from './services/locale.service';
import { registerAllLocales } from './services/registerAllLocales';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: LOCALE_ID,
      useFactory: (translate: TranslateService) => translate.currentLang,
      deps: [TranslateService],
    },
    {
      provide: MAT_DATE_LOCALE,
      useFactory: (translate: TranslateService) => translate.currentLang,
      deps: [TranslateService],
    },
    provideAppInitializer(() => {
      registerAllLocales();
      const localeService = inject(LocaleService);
      return localeService.localeInitializer();
    }),
  ],
})
export class LocaleModule {}
